export { positionElements, Positioning } from './ng-positioning';
export { PositioningService } from './positioning.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/~/ngx-bootstrap/positioning/index.js
// module id = ../../../../ngx-bootstrap/positioning/index.js
// module chunks = 3